<template>
  <b-form class="px-2 mb-3">
    <b-row>
      <b-col lg="3">
        <span class="product-creation-section-labels py-0">
          Sales Channel
        </span>
        <i class="base-tooltip" aria-hidden="true" v-b-popover.hover="salesChannelTooltip"></i>
      </b-col>
      <b-col lg="5">
        <div>
          <b-form-group class="secondary-label">
            <b-form-checkbox v-model="sales_channel.is_available_on_dine_in">
              In-Store
            </b-form-checkbox>
          </b-form-group>
        </div>
        <div>
          <b-form-group class="secondary-label">
            <b-form-checkbox v-model="sales_channel.is_available_on_estore">
              Online Store
            </b-form-checkbox>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  data() {
    return {
      salesChannelTooltip: 'Here, you may choose where this product will be available. Tick “Online Store” if it should appear on your digital stores (such as your website, mobile app, or GLife), and tick “In-store” if it should be included in your online dine-in menu.'
    }
  },
  computed: {
    ...mapFields("products", ["sales_channel"]),
  },
};
</script>
